import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';

const EmptyStateWrapper = styled<any, any>('div') `
    ${propStyles};
`;

EmptyStateWrapper.defaultProps = {
    fontSize: "inherit",
    fontFamily: "inherit",
    fontWeight: "bold",
    textAlign: "center",
    padding: "xl"
};

export const EmptyState: React.SFC<any> = ({ theme, children, ...props }) => (
    <EmptyStateWrapper
        {...props}
        {...theme.EmptyState}
    >
        {children}
    </EmptyStateWrapper>
);

export default observer(withTheme(EmptyState)) as any;


// WEBPACK FOOTER //
// ./src/Components/EmptyState.tsx